$(document).ready(function () {
  $('.swiper-featured-collection').each(function () {
    if (!$(this).hasClass('swiper-already-initiated')) {
      $(this).addClass('swiper-already-initiated')
      const featuredCollectionSwiper = new Swiper (this, {
        slidesPerView: 'auto',
        freeMode: true,
        loop: false,
        spaceBetween: 0,
        direction: 'horizontal',
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        mousewheel: {
          forceToAxis: true
        },
      });
    }

  });

});
